var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ifVisible)?_c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
    active: true,
    callback: _vm.onWaypoint,
    options: _vm.intersectionOptions
  }),expression:"{\n    active: true,\n    callback: onWaypoint,\n    options: intersectionOptions\n  }"}]}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }